var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appointment !== {})?_c('span',[(
            _vm.appointment.is_active &&
            _vm.appointment.type.toUpperCase() == 'MEDICAL'
        )?_c('b-link',{attrs:{"to":{
            name: 'appointment',
            params: {
                id: _vm.appointment.id,
                view: 'resourceTimeGridDay',
                start: _vm.appointment.sort_date
            }
        },"target":_vm.appointment.openNewTab ? '_blank' : '_self'}},[_vm._v(" "+_vm._s(_vm.text || _vm._setDateTimeDisplay(_vm.appointment.start))+" ")]):(
            _vm.appointment.is_active &&
            _vm.appointment.type.toUpperCase() == 'BOARDING'
        )?_c('b-link',{attrs:{"to":{
            name: 'boarding.reservations'
        }}},[_vm._v(" "+_vm._s(_vm.text || _vm._setDateTimeDisplay(_vm.appointment.start))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.text || _vm._setDateTimeDisplay(_vm.appointment.start))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }